import React, { useEffect, useState } from "react";
import { getAboutUs } from "../../api/commonApi";
import about1 from "../../assets/images/landingpage/about1.webp";
import about2 from "../../assets/images/landingpage/about2.webp";
import about3 from "../../assets/images/landingpage/about3.webp";
import about4 from "../../assets/images/landingpage/about4.webp";

const AboutSection = ({ id }) => {
  const [aboutData, setAboutData] = useState({
    heading: "",
    subHeading: "",
    content1: "",
  });
  const images = [about1, about2, about3, about4];

  useEffect(() => {
    fetchAboutData();
  }, []);

  const fetchAboutData = async () => {
    try {
      const res = await getAboutUs();
      if (res && res.data) {
        setAboutData(res.data);
      }
    } catch (error) {
      console.error("Error fetching about section:", error);
    }
  };
  if (!aboutData) return null;

  return (
    <section id={id} className="flex flex-col items-center px-4 py-16 bg-white">
      {/* White Card */}
      <div className="relative bg-[#FFFEF0] border border-yellow-300 rounded-2xl max-w-4xl p-10 shadow-md text-center">
        {/* About Us pill inside the div */}
        <div className="mb-6">
          <span
            className="bg-[linear-gradient(to_right,#DFC355,#FDF880,#ECDA68)] 
                       text-[#87004C] text-md font-semibold px-6 py-2 rounded-full"
          >
            About Us
          </span>
        </div>

        {/* Headings */}
        <div className="flex flex-col items-center justify-center text-center mb-6">
          <h1 className="heading-style text-[#87004C]">{aboutData.heading}</h1>
          <h2 className="heading-style text-black">{aboutData.subHeading}</h2>
        </div>

        {/* Paragraph */}
        <div
          className="text-sm text-black leading-relaxed font-sans text-center"
          dangerouslySetInnerHTML={{ __html: aboutData.content1 }}
        />
      </div>

      <div className="relative w-full max-w-6xl mx-auto mt-10 overflow-hidden">
        <div className="flex animate-scroll">
          {[...images, ...images].map((img, idx) => (
            <div key={idx} className="min-w-[25%] p-2">
              <img
                src={img}
                alt={`about-${idx}`}
                className="w-full h-60 object-cover rounded-xl shadow-md"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Tailwind custom animation */}
      <style>
        {`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-scroll {
            display: flex;
            animation: scroll 20s linear infinite;
          }
        `}
      </style>
    </section>
  );
};

export default AboutSection;
